import { useEffect } from 'react'

import getAccountPaymentInfo from '../../modules/redux/user/getAccountPaymentInfo'
import { useDispatch } from '../../modules/store/customDispatch'

export const useGetAccountPaymentInfo = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getAccountPaymentInfo())
    }, [dispatch])
}

